// extracted by mini-css-extract-plugin
export var app = "Root-module--app--3fJQQ";
export var grow = "Root-module--grow--38IwY";